class JxsCartDiscountApply extends HTMLElement {
  constructor() {
    super()
    this.applyButton = this.querySelector('button')
    this.applyButton.addEventListener('click', this.onApplyClick.bind(this))

    this.onRemoveDiscountCodeListener = this.onRemoveDiscountCode.bind(this)
    this.initRemoveCodeListener()
  }

  onApplyClick(e) {
    e.stopPropagation()
    e.preventDefault()
    if (this.querySelector('input[name="discount"]').value) {
      this.applyDiscountCode()
      this.querySelector('input[name="discount"]').value = ''
    }
  }

  initRemoveCodeListener() {
    this.querySelectorAll('.applied-code svg').forEach(item => {
      item.addEventListener('click', this.onRemoveDiscountCodeListener)
    })
  }

  onRemoveDiscountCode(e) {
    e.target.closest('.applied-code').remove()
    this.applyDiscountCode()
  }

  applyDiscountCode() {
    if (this.applyButton.hasAttribute('loading')) {
      return
    }
    const codes = []
    const newCode = this.querySelector('input[name="discount"]')?.value
    if (newCode) {
      codes.push(newCode)
    }
    this.querySelectorAll('.applied-code').forEach(item => {
      codes.push(item.dataset.code)
    })
    this.applyButton.setAttribute('loading', '')
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: [this.getAttribute('section-id')]
      })
    })
    .then(res => res.json())
    .then(data => {
      this.updateContent(data.sections[this.getAttribute('section-id')])
    })
    .finally(() => {
      this.applyButton.removeAttribute('loading')
    })
  }

  /**
 * 更新页面中的购物车内容
 * @param {string} html - AJAX 返回的完整 HTML 字符串
 */
  updateContent(html) {
    const section = document.getElementById('shopify-section-' + this.getAttribute('section-id'))
    // 1. 将 AJAX 返回的 HTML 字符串转换为 DOM 对象（便于查询）
    const parser = new DOMParser();
    const newDOM = parser.parseFromString(html, 'text/html');

    // 2. 从新 HTML 中提取需要替换的部分
    const newCartContent = newDOM.querySelector('.cart-content-item .cart')?.innerHTML;
    const newCartTotal = newDOM.querySelector('.cart-content-item .cart-total--price')?.innerHTML;
    const appliedDiscounts = newDOM.querySelector('.applied-discounts')?.innerHTML;

    // 3. 更新原始 DOM 中的对应部分
    if (newCartContent) {
      const originalCart = section.querySelector('.cart-content-item .cart');
      if (originalCart) {
        originalCart.innerHTML = newCartContent;
      }
    }

    if (newCartTotal) {
      const originalTotal = section.querySelector('.cart-content-item .cart-total--price');
      if (originalTotal) {
        originalTotal.innerHTML = newCartTotal;
      }
    }

    if (appliedDiscounts) {
      const originalappliedDiscounts = section.querySelector('.applied-discounts');
      if (originalappliedDiscounts) {
        originalappliedDiscounts.innerHTML = appliedDiscounts;
        this.initRemoveCodeListener()
      }
    }
  }

}
customElements.define('jxs-cart-discount-apply', JxsCartDiscountApply)


class JxsCartShippingCalculator extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initShippingInfo();
    const countrySelect = this.querySelector('select.country');
    countrySelect?.addEventListener('change', this.#handleCountryChange);
    countrySelect?.dispatchEvent(new Event('change', { bubbles: true }));
    this.submitButton = this.querySelector('#get-rates-submit');
    this.submitButton?.addEventListener('click', this.#handleCalculateShippingRages);

    this.loadUserAddress();
  }

  disconnectedCallback() {
    this.querySelector('select.country')?.removeEventListener('change', this.#handleCountryChange);
    this.submitButton?.removeEventListener('click', this.#handleCalculateShippingRages);
  }

  loadUserAddress() {
    const cachedData = this.getCookie('jxs_user_location')
    if (cachedData) {
      try {
        const data = JSON.parse(cachedData)
        this.initUserAddress(data.country, data.province, data.zip)
        return
      } catch (e) {
        // cookie 解析失败，继续从 ip-api 获取
      }
    }
    // 从 ip-api 获取并存入 cookie
    fetch('http://ip-api.com/json/?fields=city,regionName,country,zip')
      .then(response => response.json())
      .then(data => {
        // 存入 cookie，24小时过期
        this.setCookie('jxs_user_location', JSON.stringify({
          country: data.country,
          province: data.regionName,
          zip: data.zip
        }), 12)
        this.initUserAddress(data.country, data.regionName, data.zip)
      });
  }

  initUserAddress(country, region, zip) {
    const countrySelect = this.querySelector('select.country');
    const provinceSelect = this.querySelector('select.province');
    const zipInput = this.querySelector('input[name="address[zip]"]');

    if (!countrySelect) return;

    // 1. 匹配并设置国家 (直接匹配 value)
    const countryOption = Array.from(countrySelect.options).find(opt => opt.value === country);

    if (countryOption) {
      countrySelect.value = country;
      
      // 2. 触发 change 事件以更新省份列表
      countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
      
      // 3. 延迟设置省份和邮编
      setTimeout(() => {
        // 设置省份 (直接匹配 value)
        if (provinceSelect && region) {
          const provinceOption = Array.from(provinceSelect.options).find(opt => opt.value === region);
          if (provinceOption) {
            provinceSelect.value = region;
          }
        }
        
        // 设置邮编
        if (zipInput && zip) {
          zipInput.value = zip;
        }
      }, 300);
    }
  }

  // 获取 cookie
  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  // 设置 cookie，hours 为过期小时数
  setCookie(name, value, hours) {
    const expires = new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString()
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`
  }

  #handleCountryChange = (e) => {
    const countrySelect = e.target;
    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    const provincesData = selectedOption.getAttribute('data-provinces');
    
    if (!provincesData) {
      this.updateProvinceSelect([]);
      return;
    }

    try {
      const provinces = JSON.parse(provincesData);
      this.updateProvinceSelect(provinces);
    } catch (error) {
      console.error('[JxsCartShippingCalculator] 解析省份数据失败:', error);
    }
  }

  updateProvinceSelect(provinces) {
    const provinceSelect = this.querySelector('select.province');
    if (!provinceSelect) {
      console.warn('[JxsCartShippingCalculator] 未找到省份选择器');
      return;
    }

    // 清空现有选项
    while (provinceSelect.firstChild) {
      provinceSelect.removeChild(provinceSelect.firstChild);
    }

    // 如果省份数据为空，隐藏省份选择器容器
    const provinceContainer = this.querySelector('#address_province_container');
    provinceContainer.style.display = provinces && provinces.length > 0 ? 'inline-block' : 'none';

    // 添加新的省份选项
    for (let i = 0; i < provinces.length; i++) {
      const opt = document.createElement('option');
      opt.value = provinces[i][0];
      opt.innerHTML = provinces[i][1];
      provinceSelect.appendChild(opt);
    }
  }

  #handleCalculateShippingRages = async () => {
    if (this.submitButton.hasAttribute('disabled')) {
      return;
    }
    const respWrapper = this.querySelector('#wrapper-response');
    respWrapper.classList.remove('has-error');
    respWrapper.innerHTML = '';

    this.submitButton.classList.add('is-loading');
    this.submitButton.setAttribute('disabled', '');

    const countrySelect = this.querySelector('select.country');
    const provinceSelect = this.querySelector('select.province');
    const zipInput = this.querySelector('input[name="address[zip]"]');

    const params = new URLSearchParams({
      'shipping_address[zip]': zipInput?.value,
      'shipping_address[country]': countrySelect?.value,
      'shipping_address[province]': provinceSelect?.value || ''
    });

    try {
      const response = await fetch(`/cart/shipping_rates.json?${params}`);
      const data = await response.json();
      const rates = data.shipping_rates;
      if (rates) {
        if (rates.length > 0) {
          for (const r of rates) {
            const rateItem = document.createElement('div');
            rateItem.classList.add('rate-item');
            let price = parseFloat(r.price);
            if (price == 0) {
              price = 'Free';
            } else {
              price += ' ' + r.currency;
            }
            rateItem.innerHTML = `<strong>${price}</strong> - ${r.name}`;
            respWrapper.append(rateItem);
          }
        } else {
          respWrapper.innerHTML = 'No logistics information found.'
        }
      } else {
        let hasError = false;
        for (let msgs of Object.values(data)) {
          for (let msg of msgs) {
            const msgDiv = document.createElement('div');
            msgDiv.textContent = msg;
            respWrapper.append(msgDiv);
            hasError = true;
          }
        }
        if (hasError) {
          respWrapper.classList.add('has-error');
        }
      }
    } catch (e) {
      respWrapper.classList.add('has-error');
      respWrapper.innerHTML = 'Error, please try again.'
    }

    this.submitButton.classList.remove('is-loading');
    this.submitButton.removeAttribute('disabled');

  }

  initShippingInfo() {
    const shippingInfo = this.querySelector('.shipping-info');
    if (!shippingInfo) {
      return;
    }
    const dayFast = parseInt(shippingInfo.dataset.fastDay);
    const daySlow = parseInt(shippingInfo.dataset.slowDay);
    const msg = shippingInfo.dataset.message;

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    
    const formatDate = (date) => {
      const dayName = days[date.getDay()];
      const monthName = months[date.getMonth()];
      const dayNum = date.getDate();
      return `${dayName}, ${monthName} ${dayNum}`;
    };
    
    const today = new Date();
    const startDate = new Date(today);
    startDate.setDate(today.getDate() + dayFast);
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + daySlow);
    const dateRange = `${formatDate(startDate)} - ${formatDate(endDate)}`;

    shippingInfo.innerHTML = msg.replace('_date_', dateRange).replace(/\[(.*?)\]/g, '<strong>$1</strong>');
  }
}
customElements.define('jxs-cart-shipping-calculator', JxsCartShippingCalculator)


/*
 1、生成了自定义的arrow控制器
 2、处理padding.right设置时，最后一个item有空白
 使用方式：
 class xx extends HTMLElement {
   constructor() {
     super()
     this.splide = ...;
     this.splideControl = new SplideControl(this.splide)
     // 如果你需要自定义arrow
     this.initArrows(this.querySelector('.splide'))
     // 如果需要
     this.onSplideReady(() => ())
     this.onSplideMove(() => ())
     // 最后挂载
     this.splide.mount()
   }
 }
 */
class SplideControl {
  constructor(splide) {
    this.splide = splide

    // 当设置了padding.right后，滚动到最后一个item时，消除右侧的空白区域
    // .splide__track需要给padding设置css过度效果transition: padding .3s ease;
    this.splide.on('move', () => {
      const track = this.splide.Components.Elements.track
      const currentPadding = this.splide.options.padding
      if (currentPadding) {
        if (this.splide.index === this.splide.Components.Controller.getEnd()) {
          track.style.paddingRight = '0'
          track.style.paddingLeft = currentPadding.right + 'px'
        } else {
          track.style.paddingLeft = '0'
          track.style.paddingRight = currentPadding.right + 'px'
        }
      }
      this.updateArrowState()
      this.onSplideMoveListener && this.onSplideMoveListener()
    })
    this.splide.on('ready', () => {
      this.updateArrowState()
      this.onSplideReadyListener && this.onSplideReadyListener()
    })
  }

  initArrows(container) {
    this.arrowButtonPrev = document.createElement('button')
    this.arrowButtonPrev.classList.add('slider-arrow', 'type-float')
    this.arrowButtonPrev.setAttribute('dir', 'prev')
    this.arrowButtonPrev.innerHTML = '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" fill="currentColor"></path></svg>'
    container.appendChild(this.arrowButtonPrev)

    this.arrowButtonNext = document.createElement('button')
    this.arrowButtonNext.classList.add('slider-arrow', 'type-float')
    this.arrowButtonNext.setAttribute('dir', 'next')
    this.arrowButtonNext.innerHTML = '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M383.291616 808.954249c-5.175883 0-10.353812-1.950422-14.338566-5.862521-8.064676-7.919367-8.182356-20.877493-0.26299-28.942169l273.602402-278.620695L368.69006 216.907145c-7.919367-8.064676-7.801686-21.022803 0.26299-28.942169 8.065699-7.918343 21.022803-7.80271 28.942169 0.26299l287.685141 292.960285c7.818059 7.961322 7.818059 20.717857 0 28.67918L397.895219 802.826692C393.887952 806.907637 388.591319 808.954249 383.291616 808.954249z" fill="currentColor"></path></svg>'
    container.appendChild(this.arrowButtonNext)

    const onArrowClickListener = this.onArrowClick.bind(this)
    this.arrowButtonPrev.addEventListener('click', onArrowClickListener)
    this.arrowButtonNext.addEventListener('click', onArrowClickListener)
  }

  onArrowClick(e) {
    const btn = e.target.closest('button')
    if (btn.getAttribute('dir') == 'prev') {
      this.splide.go('<')
    } else {
      this.splide.go('>')
    }
  }

  updateArrowState() {
    if (this.arrowButtonPrev) {
      this.arrowButtonPrev.removeAttribute('disabled')
      this.arrowButtonNext.removeAttribute('disabled')
      if (this.splide.index == 0) {
        this.arrowButtonPrev.setAttribute('disabled', '')
      } else if (this.splide.index == this.splide.Components.Controller.getEnd()) {
        this.arrowButtonNext.setAttribute('disabled', '')
      }
    }
  }

  onSplideReady(callback) {
    this.onSplideReadyListener = callback
  }

  onSplideMove(callback) {
    this.onSplideMoveListener = callback
  }
}

class JxsReviewProduct extends HTMLElement {
  constructor() {
    super()

    const onContentMouseMoveListener = this.onContentMouseMove.bind(this)
    const onContentMouseLeaveListener = this.onContentMouseLeave.bind(this)
    this.querySelectorAll('.review-card__content').forEach(content => {
      content.addEventListener('mousemove', onContentMouseMoveListener)
      content.addEventListener('mouseleave', onContentMouseLeaveListener)
    })

    this.tooltipMaps = {}
    this.querySelectorAll('.jxs-review-product__content-tooltip').forEach(tp => {
      this.tooltipMaps[tp.dataset.blockId] = tp
      document.body.appendChild(tp)
    })

    this.init()
  }

  init() {
    this.splide = new Splide(this.querySelector('.splide'), {
      arrows: false,
      pagination: false,
      gap: 16,
      perPage: 4,
      breakpoints: {
        767: {
          perPage: 1,
          padding: { right: 70 }
        },
        980: {
          perPage: 2
        },
        1024: {
          perPage: 3
        }
      }
    })

    this.splideControl = new SplideControl(this.splide)
    this.splideControl.initArrows(this.querySelector('.splide'))
    this.splide.mount()
  }

  

  onContentMouseMove(e) {
    const tp = this.tooltipMaps[e.target.dataset.blockId]
    if (tp) {
      tp.style.display = 'block'
      tp.style.left = (e.clientX + window.scrollX + 10) + 'px'
      tp.style.top = (e.clientY + window.scrollY + 10) + 'px'
    }
  }

  onContentMouseLeave(e) {
    const tp = this.tooltipMaps[e.target.dataset.blockId]
    if (tp) {
      tp.style.display = 'none'
    }
  }
}
customElements.define('jxs-review-product', JxsReviewProduct);


class JxsStickyAddToCart extends HTMLElement {
  constructor() {
    super()

    this.scopeFrom = document.querySelector('product-form') || document.querySelector('.productView-container');
    this.scopeTo = document.querySelector('footer');
    this.variantData = {};
    this.onVariantChangedListener = this.onVariantChanged.bind(this);
    this.addToCartListener = this.onAdd2CartClick.bind(this);
    this.onStickyVariantChange = this.handleStickyVariantChange.bind(this);
    this.isCheckoutClick = false

    if (!this.scopeFrom || !this.scopeTo) {
      return;
    }

    const intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this));
    intersectionObserver.observe(this.scopeFrom);
    intersectionObserver.observe(this.scopeTo);

    document.addEventListener('addToCartCompleted', () => {
      this.querySelector('button[name="add"]')?.classList.remove('is-loading')
      if (this.isCheckoutClick) {
        window.location = '/checkout'
      }
      this.isCheckoutClick = false
    })

    // Listen for variant changed event
    document.addEventListener('variantChanged', this.onVariantChangedListener);
  }

  connectedCallback() {
    setTimeout(() => {
      this.variantData = this.getVariantData();

      // Cache button elements after children are available
      this.buyButton = this.querySelector('button[name="buy"]');
      this.addButton = this.querySelector('button[name="add"]');
      this.addButtonDefaultText = this.addButton?.textContent || '';
      this.variantSelect = this.querySelector('.variant-select');

      this.buyButton?.removeEventListener('click', this.addToCartListener);
      this.addButton?.removeEventListener('click', this.addToCartListener);
      this.buyButton?.addEventListener('click', this.addToCartListener);
      this.addButton?.addEventListener('click', this.addToCartListener);

      this.variantSelect?.removeEventListener('change', this.onStickyVariantChange);
      this.variantSelect?.addEventListener('change', this.onStickyVariantChange);

      // 初始化时执行一次 onVariantChanged 的逻辑
      const selectedVariant = this.getVariantById(this.dataset.selectedVariantId);
      if (selectedVariant) {
        this.onVariantChanged({ detail: { variant: selectedVariant } });
      }
    }, 0);

    this.renderDeliveryRange();
  }

  renderDeliveryRange() {
    const shippingTime = this.querySelector('.info-shipping__time');
    if (!shippingTime) return;

    const template = shippingTime.textContent;
    if (!template.includes('[date1]') && !template.includes('[date2]')) return;

    const startDays = parseInt(shippingTime.dataset.deliveryStart, 10);
    const endDays = parseInt(shippingTime.dataset.deliveryEnd, 10);
    if (!Number.isFinite(startDays) || !Number.isFinite(endDays)) return;

    const start = new Date();
    const end = new Date();
    start.setDate(start.getDate() + startDays);
    end.setDate(end.getDate() + endDays);
    shippingTime.textContent = template
      .replaceAll('[date1]', this.formatDeliveryDate(start))
      .replaceAll('[date2]', this.formatDeliveryDate(end));
  }

  formatDeliveryDate(date) {
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
    const dayOfMonth = date.toLocaleDateString('en-US', { day: '2-digit' });
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    return `${dayOfWeek}, ${dayOfMonth} ${month}`;
  }

  getVariantData() {
    const script = this.querySelector('[data-variant-data]');
    if (!script) return {};

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('JxsStickyAddToCart.getVariantData', error)
      return {};
    }
  }

  getVariantById(id) {
    if (!id) return null;
    return this.variantData[String(id)] || null;
  }

  getVariantWithInventoryPolicy(variant) {
    if (!variant) return null;

    const variantData = this.getVariantById(variant.id);
    return {
      ...variantData,
      ...variant,
      available: variantData?.available ?? variant.available,
      inventory_policy: variantData?.inventory_policy ?? variant.inventory_policy
    };
  }

  updatePriceLists(variant) {
    const formattedPrice = Shopify.formatMoney(variant.price, window.money_format);
    const priceText = window.currencyFormatted ? $(formattedPrice).text() : formattedPrice;
    const hasComparePrice = variant.compare_at_price && variant.compare_at_price > variant.price;
    const formattedComparePrice = hasComparePrice ? Shopify.formatMoney(variant.compare_at_price, window.money_format) : '';
    const comparePriceText = window.currencyFormatted ? $(formattedComparePrice).text() : formattedComparePrice;

    this.querySelectorAll('.price-list').forEach(priceList => {
      const priceSaleEl = priceList.querySelector('.price-sale');
      const priceCompareEl = priceList.querySelector('.price-compare');

      if (priceSaleEl) {
        if (window.currencyFormatted) {
          priceSaleEl.textContent = priceText;
        } else {
          priceSaleEl.innerHTML = priceText;
        }
      }

      if (priceCompareEl) {
        if (hasComparePrice) {
          if (window.currencyFormatted) {
            priceCompareEl.textContent = comparePriceText;
          } else {
            priceCompareEl.innerHTML = comparePriceText;
          }
          priceCompareEl.style.display = 'inline';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }
    });
  }

  handleStickyVariantChange(event) {
    const variant = this.getVariantById(event.target.value);
    if (!variant) return;
    this.syncMainVariant(variant);
  }

  syncMainVariant(variant) {
    const picker = document.querySelector('.productView-variants variant-radios, .productView-variants variant-selects');
    if (!picker) return;

    const formInput = document.querySelector('product-form input[name="id"]');
    if (formInput && String(formInput.value) === String(variant.id)) return;

    const optionValues = [variant.option1, variant.option2, variant.option3].filter((value) => value != null && value !== '');
    let matched = true;

    if (picker.tagName === 'VARIANT-RADIOS') {
      const fieldsets = picker.querySelectorAll('fieldset');
      optionValues.forEach((value, index) => {
        const fieldset = fieldsets[index];
        const radio = fieldset && Array.from(fieldset.querySelectorAll('input')).find((input) => input.value === value);
        if (!radio) {
          matched = false;
          return;
        }
        radio.checked = true;
      });
    } else {
      const selects = picker.querySelectorAll('select');
      optionValues.forEach((value, index) => {
        const select = selects[index];
        if (!select || !Array.from(select.options).some((option) => option.value === value)) {
          matched = false;
          return;
        }
        select.value = value;
      });
    }

    if (!matched) return;
    picker.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onVariantChanged(e) {
    const variant = this.getVariantWithInventoryPolicy(e.detail.variant);
    if (!variant) return;

    if (this.variantSelect && String(this.variantSelect.value) !== String(variant.id)) {
      this.variantSelect.value = variant.id;
    }

    this.updatePriceLists(variant);
    
    if (!variant.available) {
      // 不允许超卖 = 真正售罄
      this.setAttribute('info', 'soldout');
      // 非预售状态恢复 Buy Now 和加购按钮默认文案
      if (this.buyButton) this.buyButton.style.display = '';
      if (this.addButton) this.addButton.textContent = this.addButtonDefaultText;
      // 售罄时禁用按钮
      if (this.buyButton) this.buyButton.setAttribute('disabled', '');
      if (this.addButton) this.addButton.setAttribute('disabled', '');
    } else {
      // 根据 inventory_policy 判断是预售还是真正售罄
      if ((variant.inventory_quantity || 0) == 0 && variant.inventory_policy === 'continue') {
        // 允许超卖 = 预售/补货中
        this.setAttribute('info', 'presale');
        // 预售时隐藏 Buy Now，并将加购按钮文案改为 Pre-order
        if (this.buyButton) this.buyButton.style.display = 'none';
        if (this.addButton) {
          this.addButton.removeAttribute('disabled');
          this.addButton.textContent = window.variantStrings?.preOrder || this.addButtonDefaultText;
        }
      } else {
        // 有货，正常发货
        this.setAttribute('info', 'shipping');
        // 非预售状态恢复 Buy Now 和加购按钮默认文案
        if (this.buyButton) this.buyButton.style.display = '';
        if (this.addButton) this.addButton.textContent = this.addButtonDefaultText;
        // 有货时启用按钮
        if (this.buyButton) this.buyButton.removeAttribute('disabled');
        if (this.addButton) this.addButton.removeAttribute('disabled');
      }
    }

  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.scopeFrom) {
        this.scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this.scopeTo) {
        this.scopeToReached = entry.isIntersecting;
      }
    });

    if (this.scopeFromPassed && !this.scopeToReached) {
      this.setAttribute('show', '')
    } else {
      this.removeAttribute('show')
    }
  }

  onAdd2CartClick(e) {
    if (e.target.classList.contains('is-loading')) {
      return
    }
    e.target.classList.add('is-loading')
    this.fireRealAddToCartClick(e.target.getAttribute('name') == 'buy')
  }

  fireRealAddToCartClick(isFromCheckout) {
    this.isCheckoutClick = isFromCheckout
    document.querySelector('product-form button[name="add"][data-btn-addtocart]')?.click()
  }
}
customElements.define('jxs-sticky-add-to-cart', JxsStickyAddToCart);


class JxsModal extends HTMLElement {
  constructor() {
    super()
  }

  #handleCloseModal = () => {
    this.closeModal();
  }

  #handleOpenModal = () => {
    this.openModal();
  }

  connectedCallback() {
    const modalId = this.getAttribute('modal-id');
    this.querySelectorAll('.modal-close,[close-trigger]').forEach(btn => {
      btn.addEventListener('click', this.#handleCloseModal)
    })
    if (this.getAttribute('modal-id')) {
      const openTrigger = document.querySelector(`[open-modal-id="${modalId}"]`)
      if (openTrigger) {
        openTrigger.addEventListener('click', this.#handleOpenModal)
      }
    }

    if (this.hasAttribute('to-body')) {
      if (this.parentElement !== document.body) {
        // 查找并移除 body 中已存在的相同 modal
        const oldModal = document.body.querySelector(`:scope > jxs-modal[modal-id="${modalId}"]`);
        if (oldModal && oldModal !== this) {
          oldModal.remove();
        }
        document.body.append(this);
      }
    }
  }

  disconnectedCallback() {
    this.querySelectorAll('.modal-close,[close-trigger]').forEach(btn => {
      btn.removeEventListener('click', this.#handleCloseModal)
    })
    document.querySelector(`[open-modal-id="${this.getAttribute('modal-id')}"]`)?.removeEventListener('click', this.#handleOpenModal)
  }

  closeModal() {
    this.removeAttribute('open')
  }

  openModal() {
    this.setAttribute('open', '')
  }

  updateContent(htmlElements) {
    const content = this.querySelector('.modal-content')
    content.innerHTML = ''
    content.appendChild(htmlElements)
  }
}
customElements.define('jxs-modal', JxsModal);

class JxsVideoPlaylist extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.main = this.querySelector('.video-playlist__main')
    this.listItems = this.querySelectorAll('.video-playlist__list-item')
    
    // Add click event listeners to each list item
    this.listItems.forEach(item => {
      item.addEventListener('click', () => this.handleItemClick(item))
    })

    // 初始化后默认展示第一个列表项对应的播放器，但不自动播放
    if (this.listItems.length > 0) {
      this.handleItemClick(this.listItems[0], false)
    }
  }

  handleItemClick(item, shouldPlay = true) {
    // Update active state
    this.listItems.forEach(i => i.classList.remove('active'))
    item.classList.add('active')

    // Get video type
    const videoType = item.dataset.videoType
    const videoRatio = item.dataset.videoRatio

    // Update the video ratio CSS variable
    this.main.style.setProperty('--video-ratio', videoRatio)

    // First try YouTube
    const youtubeId = item.querySelector('[data-youtube-id]')?.dataset.youtubeId
    if (youtubeId) {
      this.playYoutubeVideo(youtubeId, shouldPlay)
      return
    }

    // Then try Shopify video
    const itemVideo = item.querySelector('video')
    if (itemVideo) {
      this.playShopifyVideo(itemVideo, shouldPlay)
    }
  }

  playShopifyVideo(itemVideo, shouldPlay = true) {
    // Clone the video element and replace main content
    const newVideo = itemVideo.cloneNode(true)
    newVideo.style.display = 'block'
    newVideo.removeAttribute('controls')
    newVideo.setAttribute('controls', true)
    newVideo.muted = false

    // Clear main and append new video
    this.main.innerHTML = ''
    this.main.appendChild(newVideo)

    if (shouldPlay) {
      // Auto-play the new video
      newVideo.play().catch(() => {
        // Auto-play might be blocked by browser policies, ignore silently
      })
    } else {
      newVideo.pause()
      newVideo.currentTime = 0
    }
  }

  playYoutubeVideo(youtubeId, shouldPlay = true) {
    // Create a container for the YouTube player
    const playerContainer = document.createElement('div')
    playerContainer.id = 'youtube-player-' + Math.random().toString(36).substr(2, 9)
    playerContainer.style.width = '100%'
    playerContainer.style.height = '100%'

    // Clear main and append player container
    this.main.innerHTML = ''
    this.main.appendChild(playerContainer)

    // Load YouTube API if not already loaded
    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
      // Store current youtube id for callback
      window._currentYoutubeId = youtubeId
      window._currentYoutubeContainerId = playerContainer.id
      window._currentYoutubeShouldPlay = shouldPlay

      if (typeof window.onYouTubeIframeAPIReady === 'undefined') {
        window.onYouTubeIframeAPIReady = () => {
          this.createYoutubePlayer(window._currentYoutubeContainerId, window._currentYoutubeId, window._currentYoutubeShouldPlay)
        }

        // Load YouTube API script
        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'
        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
      } else {
        // API already loading, just set callback
        const originalCallback = window.onYouTubeIframeAPIReady
        window.onYouTubeIframeAPIReady = () => {
          originalCallback()
          this.createYoutubePlayer(window._currentYoutubeContainerId, window._currentYoutubeId, window._currentYoutubeShouldPlay)
        }
      }
    } else {
      // YouTube API already loaded, create player directly
      this.createYoutubePlayer(playerContainer.id, youtubeId, shouldPlay)
    }
  }

  createYoutubePlayer(containerId, youtubeId, shouldPlay = true) {
    // Destroy existing player if any
    if (this.youtubePlayer) {
      try {
        this.youtubePlayer.destroy()
      } catch (e) {
        // Ignore destroy errors
      }
    }

    // Create new YouTube player using SDK
    this.youtubePlayer = new YT.Player(containerId, {
      videoId: youtubeId,
      playerVars: {
        autoplay: shouldPlay ? 1 : 0,
        controls: 1,
        disablekb: 0,
        enablejsapi: 1,
        fs: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      events: {
        onReady: (event) => {
          if (shouldPlay) {
            event.target.playVideo()
          }
        },
        onStateChange: (event) => {
          // Handle player state changes if needed
          if (event.data === YT.PlayerState.ENDED) {
            // Video ended, you can add logic here
          }
        }
      }
    })
  }
}
customElements.define('jxs-video-playlist', JxsVideoPlaylist);


class JxsProductTab extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.splide = new Splide(this.querySelector('.splide'), {
      autoWidth: true,
      arrows: false,
      pagination: false
    })
    this.splide.mount()

    this.tabItems = Array.from(this.querySelectorAll('.tab-bar li'))
    this.tabPanels = Array.from(this.querySelectorAll('.tab-content-panel'))
    
    // Set first tab as active by default
    if (this.tabItems.length > 0) {
      this.setActiveTab(this.tabItems[0].dataset.index)
    }

    // Add click event listeners to tab items
    this.tabItems.forEach(item => {
      item.addEventListener('click', () => this.handleTabClick(item))
    })

    document.querySelector('.productView-product .jdgm-preview-badge')?.addEventListener('click', this.#handleReviewClick);
  }

  disconnectedCallback() {
    this.splide.destroy(true)
    document.querySelector('.productView-product .jdgm-preview-badge')?.removeEventListener('click', this.#handleReviewClick);
  }

  handleTabClick(item) {
    const index = item.dataset.index
    this.setActiveTab(index, true)
  }

  setActiveTab(index, scrollToStart) {
    // Update tab items active state
    this.tabItems.forEach(item => {
      if (item.dataset.index === index) {
        item.setAttribute('active', '')
      } else {
        item.removeAttribute('active')
      }
    })

    // Update tab panels visibility
    this.tabPanels.forEach(panel => {
      if (panel.dataset.index === index) {
        panel.setAttribute('active', '')
        if (scrollToStart) {
          const top = panel.getBoundingClientRect().top + window.scrollY - 100
          window.scrollTo({ top, behavior: 'smooth' })
        }
      } else {
        panel.removeAttribute('active')
      }
    })
    this.splide.go(parseInt(index))
  }

  #handleReviewClick = () => {
    const reviewWidget = this.querySelector('.tab-content-panel .jdgm-review-widget');
    if (reviewWidget) {
      const index = reviewWidget.closest('.tab-content-panel')?.dataset.index;
      if (index) {
        this.setActiveTab(index, true);
      }
    }
  }
}
customElements.define('jxs-product-tab', JxsProductTab);


class JxsSoftwareUpgradeDesc extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.pageUrl = this.dataset.pageUrl
    if (!this.pageUrl) {
      console.error('JxsSoftwareUpgradeDesc: 缺少 data-page-url 属性')
      return
    }
    this.loadContent()
  }

  loadContent() {
    fetch(this.pageUrl)
      .then(res => {
        if (!res.ok) {
          throw new Error('请求失败：' + res.status)
        }
        return res.text()
      })
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        // 读取 main 里所有的 .shopify-section
        const main = doc.querySelector('main')
        if (!main) {
          console.error('JxsSoftwareUpgradeDesc: 未找到 main 元素')
          return
        }

        const sections = main.querySelectorAll('.shopify-section')
        if (!sections.length) {
          console.error('JxsSoftwareUpgradeDesc: main 内未找到 .shopify-section')
          return
        }

        const container = this.querySelector('.page-html')

        sections.forEach(section => {
          container.appendChild(section)
        })
      })
      .catch(error => {
        console.error('JxsSoftwareUpgradeDesc.loadContent', error)
      })
  }
}
customElements.define('jxs-software-upgrade-desc', JxsSoftwareUpgradeDesc);


class JxsSoftwareUpgradeCollection extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') {
      return
    }
    this.dataset.initialized = 'true'

    this.searchInput = this.querySelector('[data-software-upgrade-search]')
    this.rows = Array.from(this.querySelectorAll('[data-software-upgrade-row]'))
    this.emptyRow = this.querySelector('[data-software-upgrade-empty]')
    this.pagination = this.querySelector('[data-software-upgrade-pagination]')

    if (!this.searchInput || !this.rows.length) {
      return
    }

    this.PAGE_SIZE = 12
    this.currentPage = 1

    this.searchInput.addEventListener('input', () => this.filterRows())
    this.filterRows()
  }

  getPageNumbers(current, total) {
    const delta = 1
    const pages = []
    const range = []

    for (let i = 1; i <= total; i += 1) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i)
      }
    }

    let previous = 0
    range.forEach((page) => {
      if (previous) {
        if (page - previous === 2) {
          pages.push(previous + 1)
        } else if (page - previous > 2) {
          pages.push('...')
        }
      }
      pages.push(page)
      previous = page
    })

    return pages
  }

  renderPagination(totalPages) {
    if (!this.pagination) {
      return
    }

    this.pagination.innerHTML = ''

    if (totalPages <= 1) {
      this.pagination.hidden = true
      return
    }

    this.pagination.hidden = false

    const createButton = (label, page, options = {}) => {
      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'software-upgrade-collection__page-button'
      button.textContent = label

      if (options.active) {
        button.classList.add('is-active')
      }

      if (options.disabled) {
        button.disabled = true
      } else {
        button.addEventListener('click', () => {
          this.currentPage = page
          this.renderRows()
        })
      }

      return button
    }

    this.pagination.appendChild(
      createButton('‹', this.currentPage - 1, { disabled: this.currentPage === 1 })
    )

    this.getPageNumbers(this.currentPage, totalPages).forEach((page) => {
      if (page === '...') {
        const ellipsis = document.createElement('span')
        ellipsis.className = 'software-upgrade-collection__page-ellipsis'
        ellipsis.textContent = '…'
        this.pagination.appendChild(ellipsis)
      } else {
        this.pagination.appendChild(
          createButton(String(page), page, { active: page === this.currentPage })
        )
      }
    })

    this.pagination.appendChild(
      createButton('›', this.currentPage + 1, { disabled: this.currentPage === totalPages })
    )
  }

  renderRows() {
    const keyword = this.searchInput.value.trim().toLowerCase()
    const matchedRows = this.rows.filter((row) => (row.dataset.productTitle || '').includes(keyword))
    const totalPages = Math.max(1, Math.ceil(matchedRows.length / this.PAGE_SIZE))

    if (this.currentPage > totalPages) {
      this.currentPage = totalPages
    }

    const startIndex = (this.currentPage - 1) * this.PAGE_SIZE
    const endIndex = startIndex + this.PAGE_SIZE
    let displayedCount = 0

    this.rows.forEach((row) => {
      row.hidden = true
      row.classList.remove('software-upgrade-collection__row--alternate')
    })

    matchedRows.forEach((row, index) => {
      if (index >= startIndex && index < endIndex) {
        row.hidden = false
        if (displayedCount % 2 === 1) {
          row.classList.add('software-upgrade-collection__row--alternate')
        }
        displayedCount += 1
      }
    })

    if (this.emptyRow) {
      this.emptyRow.hidden = matchedRows.length > 0
    }

    this.renderPagination(totalPages)
  }

  filterRows() {
    this.currentPage = 1
    this.renderRows()
  }
}
customElements.define('jxs-software-upgrade-collection', JxsSoftwareUpgradeCollection);
